/* eslint-disable camelcase */
import { Card, Container, Divider, Grid, Modal, Stack, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import instance from '../../api/axiosRequest';
import Page from '../../components/Page';
import Transactions from './Transactions';
import Payments from './Payments';

export default function Wallet() {
  const [credits, setCredits] = useState([]);
  useEffect(() => {
    const getwallet = async () => {
      try {
        const { data } = await instance.get('/payment/getCredits');
        setCredits(data.data.rows);
      } catch (error) {
        console.log(error);
      }
    };
    getwallet();
  }, []);

  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;

    document.body.appendChild(script);

    return () => document.body.removeChild(script);
  }, []);

  return (
    <Page title="Wallet">
      <Container>
        <Typography variant="h4">Wallet</Typography>
        <Grid container spacing={4} mb={4}>
          <Grid item xs={12} md={4}>
            <BalanceCard title="Email Credits" details={credits[0]?.credits || 0} />
          </Grid>
          <Grid item xs={12} md={4}>
            <BalanceCard title="SMS Credits" details={credits[1]?.credits || 0} />
          </Grid>
          <Grid item xs={12} md={4}>
            <BalanceCard title="Whatsapp Credits" details={credits[2]?.credits || 0} />
          </Grid>
        </Grid>
      </Container>
      <Transactions />
      <br />
      <Payments />
    </Page>
  );
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 960,
  width: '90%',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

function BalanceCard({ details, title }) {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const buyMore = async (e) => {
    e.preventDefault();
    if (!title.includes('Email')) return;
    try {
      setLoading(true);
      const { data } = await instance.post('/payment/create', {
        amount,
        is_wallet_transaction: 0,
        service_id: 0,
      });
      const rzp1 = new window.Razorpay({
        key: 'rzp_test_hBCtetMz3pVVcf',
        amount: data.data.amount,
        currency: data.data.currency,
        name: 'ORM',
        description: 'Test Transaction',
        image: 'https://devepanel.web.app/static/media/logos.9b7d05c0aab806f040b2.png',
        order_id: data.data.id,
        handler: async ({ razorpay_payment_id, razorpay_order_id, razorpay_signature }) => {
          await instance.post('/payment/verification', {
            order_id: data.data.id,
            razorpay_payment_id,
            razorpay_order_id,
            razorpay_signature,
          });
          navigate(0);
          setLoading(false);
        },
        prefill: {
          name: user.name,
          email: user.email,
          contact: user.phone,
        },
        theme: {
          color: '#FF2C04',
        },
      });
      rzp1.on('payment.failed', (response) => {
        console.log(response.error);
      });
      rzp1.open();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <Card sx={{ p: 2, width: '100%', borderRadius: 1 }}>
      <Typography fontSize="0.8em" color="gray">
        {title}
      </Typography>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h5" mt={1}>
          {details}
        </Typography>
        <LoadingButton onClick={() => setModalOpen(true)} variant="contained">
          Buy more
        </LoadingButton>
      </Stack>
      <Modal open={modalOpen} setOpen={setModalOpen}>
        <form onSubmit={buyMore}>
          <Grid sx={style} container>
            <Grid item xs={12} md={7} sx={{ p: 8 }}>
              <TextField
                value={amount}
                label="Number of email credits"
                type="number"
                required
                onChange={(e) => setAmount(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={5} sx={{ backgroundColor: '#c0ccdaee', p: 4 }}>
              <Typography variant="h5">Purchase Summary</Typography>
              <br />
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="h6">{amount} email credits</Typography>
                <Typography variant="h6">&#8377;{amount}</Typography>
              </Stack>
              <Divider />
              <Typography variant="h3" textAlign="right">
                &#8377;{amount}
              </Typography>
              <LoadingButton sx={{ mt: 2 }} type="submit" loading={loading} variant="contained">
                Proceed to checkout
              </LoadingButton>
            </Grid>
          </Grid>
        </form>
      </Modal>
    </Card>
  );
}

BalanceCard.propTypes = {
  details: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
